var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 90,
    fill: "#E85A58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6717 77.7502C94.2572 73.0663 100.227 70 107.172 70C122.359 70 134.672 82.312 134.672 97.5V135H124.672V97.5C124.672 87.835 116.837 80 107.172 80C97.5067 80 89.6717 87.835 89.6717 97.5V135H79.6717V72.5H89.6717V77.7502ZM54.6716 62.5C50.5295 62.5 47.1716 59.1421 47.1716 55C47.1716 50.8578 50.5295 47.5 54.6716 47.5C58.8137 47.5 62.1716 50.8578 62.1716 55C62.1716 59.1421 58.8137 62.5 54.6716 62.5ZM49.6716 72.5H59.6716V135H49.6716V72.5Z",
    fill: "#F6E7CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.cf8ba1ff9e80f58f584e41ef46f58229.svg";
export { ForwardRef as ReactComponent };